import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import logo from '../../assets/img/logo.png';
import { NavLink } from 'react-router-dom';
import useIsPrivate from '../../hooks/useIsPrivate';
import Button from '@mui/material/Button';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      backgroundColor: theme.palette.primary.main,
      textAlign: 'start',
      color: '#fff',
      padding: '20px 0',
      '& img': {
        width: 50,
      },
    },
    button: {
      backgroundColor: '#739dc2 !important',
      color: 'white !important',
      '&:hover': {
        backgroundColor: '#407aac !important',
      },
    },
  };
});

const Header = () => {
  const classes = useStyles();
  const isPrivate = useIsPrivate();

  return (
    <Grid container className={classes.container} alignItems="center">
      <Grid item xs={12} md={9} display={'flex'}>
        <Grid item>
          {isPrivate ? (
            <NavLink to="/">
              <img className={classes.logo} src={logo} alt="logo"></img>
            </NavLink>
          ) : (
            <img className={classes.logo} src={logo} alt="logo"></img>
          )}
        </Grid>
        <Grid item>
          <Typography variant="h5">ASSONAVE</Typography>
          <Typography variant="subtitle1">
            Associazione Nazionale dell'Industria Navalmeccanica
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} md={3}>
        <Button
          variant="contained"
          color="secondary"
          className={classes.button}
          onClick={() =>
            window.open('https://www.assonave.it')
          }
        >
          Sito Area pubblica assonave
        </Button>
      </Grid>
    </Grid>
  );
};

export default Header;
